// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2zi1P","circle":"style_circle__27zW4","outer":"style_outer__2loHN","inner":"style_inner__1GLIc","onScreen":"style_onScreen__2hFeq"};